import apiClient from '@/services/axios'

export async function post(userId, payload) {
  var response = await apiClient.post('/userMemberCards/' + userId, payload)
  if (response) {
    return response.data
  }

  throw new Error('Unable to add User Member Card.')
}